import request from "@/utils/request"
export const applicationAgent = (user_id) => {

    return request({
      method: "POST",
      data: {user_id},
      url: "/handle/agent/weidaili",
    });
  };
  export const sqdl = (user_id) => {

    return request({
      method: "POST",
      data: {user_id},
      url: "/handle/agent/weidaili",
    });
  };
  // 申请代理
  export const shenqing = (params) => {

    return request({
      method: "POST",
      data: params,
      url: "/handle/agent/shenqing",
    });
  };


// WEBPACK FOOTER //
// ./src/api/system/applicationAgent.js